// extracted by mini-css-extract-plugin
export default {"contextMenu":"ContextMenu_contextMenu__uGlIj","contextMenuItem":"ContextMenu_contextMenuItem__cZKjY","line":"ContextMenu_line__bsUwm","nameItem":"ContextMenu_nameItem__-7Cpo"};